import 'library/styles/components/feedback-button.scss';
import React from 'react';
import Modal from 'library/helpers/modal';
import Ajax from 'axios';
import { uuid } from 'library/helpers/text';
import Loader from 'library/icons/loader.svg';
import CaretSvg from 'library/icons/caret.svg';

const MapSelectOptions = (values) => {
  const out = [
    <option key="choose-one" value="">-- Choose One --</option>
  ];

  for (let key in values) {
    out.push(
      <option key={key} value={key}>
        { values[key] }
      </option>
    );
  }

  return out;
};

const Select = ({ question, ...props }) => (
  <select {...props}>
    { MapSelectOptions(question.values) }
  </select>
);

const Textarea = ({ question, ...props }) => (
  <textarea {...props}>
    { props.value }
  </textarea>
);

const InputElement = ({ question, ...props }) => (
  <input type={question.type} {...props} />
);

const ElementMap = {
  'select': Select,
  'textarea': Textarea
};

class FeedbackModal extends React.Component {
    static defaultProps = {
      defaultValues: {}
    }

    constructor(...params) {
      super(...params);

      this.state = {
        step: 0,
        values: {...this.props.defaultValues},
        saving: false
      };
    }

    next = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState((nextState) => {
        nextState.step++;
        return nextState;
      }, this.checkAndSendIfLast);
    }

    prev = () => {
      this.setState((nextState) => {
        nextState.step--;
        return nextState;
      });
    }

    checkAndSendIfLast = () => {
      const { questions } = this.props.form;
      const { step } = this.state;

      if (step === questions.length) {
        this.save();
      }
    }

    getValues = () => {
      const { questions } = this.props.form;
      const { values } = this.state;

      return questions.map((q) => ({
        label: q.label,
        name: q.props.name,
        value: values[q.props.name]
      }));
    }

    save = () => {
      this.setState({
        saving: true,
        error: false
      });

      Ajax
        .put(
          `https://api.pairin.com/v1/feedback/${uuid()}.json`,
          {
            template: this.props.template || 'feedback-email',
            subject: this.props.feedback || 'Thank you for your feedback',
            responses: this.getValues()
          }
        ).catch((e) => {
          console.error(e);
          this.setState({
            error: true
          });
        }).then(() => {
          this.setState({
            saving: false
          });
        });
    }

    handleChange = (e) => {
      const { value, name } = e.currentTarget;
      this.setState((nextState) => {
        nextState.values[name] = value;
        return nextState;
      });
    }

    renderError = () => {
      if (this.state.error) {
        return (
          <div className="feedback-modal-error">
                    There was an error saving your feedback. <span onClick={this.save} className="a">Try Again</span>
          </div>
        );
      }
      return null;
    }

    renderQuestions = () => {
      const { questions, thankyou={message:''} } = this.props.form;
      const { step, values } = this.state;

      if (step >= questions.length) {
        let message = thankyou.message;
        if (!Array.isArray(message)) {
          message = [message];
        }
        return (
          <div>
            { this.renderError() }
            { thankyou.message.map(m=><p>{m}</p>) }
          </div>
        );
      }

      const currentQuestion = questions[step];
      const Component = ElementMap[currentQuestion.type] || (typeof currentQuestion.type === 'function' ? currentQuestion.type : InputElement);

      return (
        <div className="feedback-modal-field">
          <span>{currentQuestion.label}</span>
          <Component
            question={currentQuestion}
            onChange={this.handleChange}
            value={values[currentQuestion.props.name] || ''}
            {...currentQuestion.props}
          />
        </div>
      );
      return null;
    }

    close = () => {
      this.props.close();
      this.props.onComplete();
    }

    renderButtons = () => {
      const { questions } = this.props.form;
      const { step, saving } = this.state;

      if (step >= questions.length) {
        return (
          <button className="feedback-modal-button-full" disabled={saving} type="button" key="close" onClick={this.close}>
            {
              saving
                ? (
                  <span className="animate-spin">
                    <Loader style={{display:'block'}} width={'1em'} height={'1em'} />
                  </span>
                )
                : 'close'
            }
          </button>
        );
      }

      const out = [
        <button className="feedback-modal-button-full" type="submit" key="next">
          Next
        </button>
      ];

      if (step !== 0) {
        out.unshift(
          <button className="button-auxilary-4" type="button" key="prev" onClick={this.prev}>
            <CaretSvg style={{display: 'block'}} width="1em" height="1em" />
          </button>
        );
      }

      return out;
    }

    render() {
      const { form } = this.props;
      return (
        <form onSubmit={this.next} className="feedback-modal-inner">
          <div className="feedback-modal-header">
            { form.title }
            <span onClick={this.props.close} className="feedback-modal-close">
              ✕
            </span>
          </div>
          <div className="feedback-modal-body">
            { this.renderQuestions() }
          </div>
          <div className="feedback-modal-footer">
            { this.renderButtons() }
          </div>
        </form>
      );
    }
}

export default class FeedbackButton extends React.Component {
    static defaultProps = {
      component: 'button',
      onComplete: ()=>{},
      onClick: ()=>{},
      defaultValues: {},
      template: 'feedback-email'
    }

    start = (e) => {
      const {
        form,
        onComplete,
        close,
        defaultValues,
        template,
        onClick
      } = this.props;

      if (typeof onClick === 'function') {
        onClick(e);
      }

      if (this.isrunning) {
        return false;
      }

      this.modal = new Modal('feedback-modal', true, {
        className: 'feedback-modal'
      });

      this.modal.render(FeedbackModal, {
        form: form,
        onComplete: onComplete,
        close: this.close,
        defaultValues: defaultValues,
        template: template
      });

      this.isrunning = true;
    }

    close = () => {
      if (this.modal) {
        this.isrunning = false;
        this.modal.unmount();
        this.modal = null;
      }
    }

    render() {
      const { component:Component='button', children, form, onClick, ...props } = this.props;
      return (
        <Component onClick={this.start} {...props}>
          { this.props.children }
        </Component>
      );
    }
}
